import React from 'react';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAndrologyData } from '../../../../actions/andrologyAction';
import { getNestedState } from '../utils/index';
import { normalValues } from '../../../../constants/normalValues';

const SeminalFluidAnalysis = ({ keyPath }) => {
  const dispatch = useDispatch();
  const seminalFluidAnalysis = useSelector((state) => getNestedState(state.andrologyReducer, keyPath));
  const semenAnalysis = useSelector((state) => getNestedState(state.andrologyReducer, `${keyPath.split('.')[0]}.spermAnalysis`));

  const handleChange = (key, value) => {
    dispatch(setAndrologyData(`${keyPath}.${key}`, value));
  };

  return (
    <Box flex={1}>
      <Paper className="p-3 mb-3">
        <Typography variant="h6" gutterBottom>
          Analysis of Seminal Fluid
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>Parameter</TableCell>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>Value</TableCell>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>WHO Normal Values</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Appearance</TableCell>
                <TableCell>
                  <TextField
                    value={seminalFluidAnalysis.appearance}
                    onChange={(e) => handleChange('appearance', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                  className='normal-value'
                    disabled
                    value={normalValues.seminalFluidAnalysis.appearance}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Liquefaction Time</TableCell>
                <TableCell>
                  <TextField
                    value={seminalFluidAnalysis.liquefactionTime}
                    onChange={(e) => handleChange('liquefactionTime', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                  className='normal-value'
                    disabled
                    value={normalValues.seminalFluidAnalysis.liquefactionTime}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Viscosity</TableCell>
                <TableCell>
                  <TextField
                    type='number'
                    onWheel={(e) => e.target.blur()}
                    value={seminalFluidAnalysis.viscosity}
                    onChange={(e) => handleChange('viscosity', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                  className='normal-value'
                    disabled
                    value={normalValues.seminalFluidAnalysis.viscosity}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Volume</TableCell>
                <TableCell>
                  <TextField
                   onWheel={(e) => e.target.blur()}
                    type='number'
                    value={seminalFluidAnalysis.volume}
                    onChange={(e) => {
                      
                      handleChange('volume', e.target.value)
                      try {
                        const spermCount = semenAnalysis.spermCount;
                        if (spermCount>0){
                          const totalCount = spermCount * e.target.value;
                          dispatch(setAndrologyData(`${keyPath.split('.')[0]}.spermAnalysis.totalCount`, totalCount));
                        }
                      }catch(e){
                        
                      }
       
                    }}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                  className='normal-value'
                    disabled
                    value={normalValues.seminalFluidAnalysis.volume}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>pH</TableCell>
                <TableCell>
                  <TextField
                   onWheel={(e) => e.target.blur()}
                    type='number'
                    value={seminalFluidAnalysis.ph}
                    onChange={(e) => handleChange('ph', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                  className='normal-value'
                    disabled
                    value={normalValues.seminalFluidAnalysis.ph}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Agglutination</TableCell>
                <TableCell>
                  <TextField
                    value={seminalFluidAnalysis.agglutination}
                    onChange={(e) => handleChange('agglutination', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                  className='normal-value'
                    disabled
                    value={normalValues.seminalFluidAnalysis.agglutination}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Round Cell Count</TableCell>
                <TableCell>
                  <TextField
                    value={seminalFluidAnalysis.roundCellCount}
                    onChange={(e) => handleChange('roundCellCount', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                  className='normal-value'
                    disabled
                    value={normalValues.seminalFluidAnalysis.roundCellCount}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default SeminalFluidAnalysis;